import React, { useState, createContext } from 'react';
export const TemplateCodeContext = createContext({
  templateCode1: "",
  // tslint:disable-next-line:no-empty
  setTemplateCode1: (value: string) : void => {/**/ }, /* tslint:disable:no-empty */
  templateCode2: "",
  // tslint:disable-next-line:no-empty
  setTemplateCode2: (value: string) : void => {/**/}, /* tslint:disable:no-empty */
  templateCode3: "",
  // tslint:disable-next-line:no-empty
  setTemplateCode3: (value: string) : void => {/**/}, /* tslint:disable:no-empty */
  templateCode4: "",
  // tslint:disable-next-line:no-empty
  setTemplateCode4: (value: string) : void => {/**/} /* tslint:disable:no-empty */
});

const TemplateCodeContextProvider = (props: any) => {
  const [templateCode1, setTemplateCode1] = useState("");
  const [templateCode2, setTemplateCode2] = useState("");
  const [templateCode3, setTemplateCode3] = useState("");
  const [templateCode4, setTemplateCode4] = useState("");

  return (
    <TemplateCodeContext.Provider
      value={{
        templateCode1,
        setTemplateCode1,
        templateCode2,
        setTemplateCode2,
        templateCode3,
        setTemplateCode3,
        templateCode4,
        setTemplateCode4
      }}
    >
      {props.children}
    </TemplateCodeContext.Provider>
  );
};
export default TemplateCodeContextProvider;
